import { ofType } from 'redux-observable';
import { filter, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { canWorkspaceBeEmpty } from 'state/workspaces/model';
import { ordersBasketTabContentAllFetched } from 'state/workspaces/ordersBasket/meta/meta.actions';
import { applyPersistedWorkspaceTabsThunk, workspaceTabCreatedThunk } from 'state/workspaces/workspace.thunks';

// TODO: Thunk
export function applyOrCreateTabOnTabsFetchedEpic(): EpicWithThunk {
  return (actions$, _state$) =>
    actions$.pipe(
      ofType('WORKSPACE_TABS_FETCHED'),
      filter(action => !canWorkspaceBeEmpty(action.workspace)),
      mergeMap(({ tabs, activeTabId, workspace, isEssentialTabsPanelShown }) => {
        if (tabs.length === 0) {
          if (workspace === 'ordersBasket') {
            return [applyPersistedWorkspaceTabsThunk([], undefined, workspace), ordersBasketTabContentAllFetched()];
          }

          return [workspaceTabCreatedThunk(workspace, 'quote')];
        }

        return [applyPersistedWorkspaceTabsThunk(tabs, activeTabId, workspace, isEssentialTabsPanelShown)];
      }),
    );
}
